// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Gn-z","badgeLink":"Hn-z","category":"In-z"};